import React from "react";
import "./step_order.css";
import "./step_style.css";
import "./step_style_sm.css";
import "./step_style_md.css";
import "./step_style_lg.css";
import "./step_style_xl.css";
import "./step_animation.css";
import "./step_animation_sm.css";
import "./step_animation_md.css";
import "./step_animation_lg.css";
import "./step_animation_xl.css";
import steps from "./process.json";


class Process extends React.Component {

  state = {
    isHovered: false,
    index: ""
  }

  handleHover = (index) => {
    this.setState({
        isHovered: true,
        index: index
    });
  }

  handleLeave = (index) => {
    this.setState({
        isHovered: false,
        index: index
    });
  }

    render(){
    const animateClass = this.state.isHovered ? "red-square" : "red-square-before"

    return (
        <div className='process_container'>
            <h4 className='col-12 text-center pt-5'>Our Process</h4>
            <div id="process" className='row pt-5 px-5 mx-auto'>

                {steps.map((step, index) => {
                    return (
                        <div key={`${step}${index}`}className='step-order p-0 mb-5 col-12 col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-4'>
                            <div className='row col-12 p-0 mx-auto'>
                                <div onMouseEnter={() => {this.handleHover(index)}} onMouseLeave={() => {this.handleLeave(index)}} className='step text-white col-3 col-sm-3 col-md-3 col-lg-3 col-xl-2 border border-dark row text-center p-2 m-0'>
                                    <div className='col-12 p-0 mx-auto'>
                                        <small>Step</small>
                                    </div>
                                    <div className='col-12 p-0'>
                                        {step.id}
                                    </div>
                                    <div className={this.state.index === index ? animateClass : "red-square-before"}>
                                        {step.info}
                                    </div>
                                </div>
                                <div className='border border-dark border-left-0 col-7 col-sm-7 col-md-7 col-lg-7 col-xl-8 p-0 py-2'>
                                    <div className='col-12'>
                                        <small>{step.step}</small>
                                    </div>
                                </div>
                                <div className='step-line position-absolute col-2 col-sm-2'>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
}
};

export default Process;


// WEBPACK FOOTER //
// ./src/components/Services/Process/Process.js